// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import Loading from '../../../_common/Loading';
import Page from '../../pageLayout/Page';
import { QuestRoute } from '../../../_common/api/QuestRoutes';
import ItemList from '../../ItemList';
import { HamQuest } from '../../../../App';

const Bundles = () => {
    const [bundles, setBundles] = useState(null);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.bundles)
            .then((res) => setBundles(res))
    }, [])

    if (!bundles) return <Loading />

    return (
        <Page>
            <ItemList items={bundles} />
        </Page>
    );
}

export default Bundles;